import { createSvgComponent } from "../../icon/createSvgComponent";
import ChatbubbleWrite from "@core/__generated__/icon/figma/chatbubble-write.svg";
export default createSvgComponent(ChatbubbleWrite);